// Charts
import { followerGrowthHistoryConfig } from '@/lib/analytics/charts/pinterest/followerGrowthHistory';
import { followersEvolutionConfig } from '@/lib/analytics/kpis/pinterest/followersEvolution';
import { followersEvolutionPercentageConfig } from '@/lib/analytics/kpis/pinterest/followersEvolutionPercentage';
// Kpis
import { totalFollowersConfig } from '@/lib/analytics/kpis/pinterest/totalFollowers';
import { SIZE_FULL } from '@/lib/gridElements/size';

export const CommunityPinterest = [
    totalFollowersConfig,
    followersEvolutionConfig,
    followersEvolutionPercentageConfig,
    { ...followerGrowthHistoryConfig, size: SIZE_FULL }
];

export const requestPinterestParams = [
    [
        'followers',
        'followers_evolution',
        'followers_evolution_percentage',
        'follower_growth_history'
    ]
];
